import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, EditorFieldProps, FieldVariant, FileFieldProps } from '@/components/form-builder/form-builder.types';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';
import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';

interface getPPMCommitteeReviewDialogProps {
  store: PpmRepository;
  validate: () => void;
}

export const getPPMCommitteeReviewDialog = ({ store, validate }: getPPMCommitteeReviewDialogProps): DialogObject => {
  const editorField: DynamicField<EditorFieldProps> = {
    label: 'ppm.form.review',
    variant: FieldVariant.EDITOR,
    isRequired: true,
    props: {
      value: store.getNested('review', 'comment'),
      onChange: (value: string) => store.setNested('review', 'comment', value),
      placeholder: 'ppm.form.placeholders.comment',
      height: '200px',
    },
  };

  const fileField: DynamicField<FileFieldProps> = {
    label: '',
    variant: FieldVariant.FILE,
    props: {
      mode: 'basic',
      accept: 'application/pdf',
      multiple: true,
      value: store.getNestedObservable<File[]>('review', 'files'),
      onFileSelect: (event: FileSelectEvent) => {
        store.setNested('review', 'files', event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        store.setNested(
          'review',
          'files',
          store.getNested<File[]>('review', 'files').filter(file => file.name !== event.file.name)
        );
      },
    },
  };

  return {
    title: 'ppm.form.reporterReview',
    actions: [
      {
        label: 'ppm.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    width: '50vw',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [editorField],
                },
                {
                  fields: [fileField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
